import {
  Networks,
  XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS,
} from '@rango-dev/wallets-shared';

export const SUPPORTED_NETWORKS = XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS;
export const SUPPORTED_ETH_CHAINS = [
  Networks.POLYGON,
  Networks.ETHEREUM,
  Networks.BSC,
  Networks.AVAX_CCHAIN,
  Networks.FANTOM,
  Networks.ARBITRUM,
];
export const SUPPORTED_COSMOS_CHAINS = [
  Networks.COSMOS,
  Networks.AKASH,
  Networks.AXELAR,
  Networks.CRYPTO_ORG,
  Networks.JUNO,
  Networks.KUJIRA,
  Networks.MARS,
  Networks.OSMOSIS,
  Networks.STARGAZE,
  Networks.STRIDE,
];
